/** @format */

import Sync from "@croco/sync";
import * as dummy from "./mock-data.js";

class Mock {
  /**
   * 解析結果一覧
   * @param {number} analytic_id 解析ID
   */
  requestPages(analytic_id) {
    console.log({ analytic_id });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const analytic = dummy.accepts.find((v) => v.id == analytic_id);
        resolve({
          success: true,
          analytic,
          items: dummy.details,
          keyphrase: dummy.keyphrase.origin,
          radar: dummy.radar[0],
        });
      }, 500);
    });
  }

  /**
   * 解析結果詳細
   * @param {number} target_id ターゲットID
   */
  requestPageDetail(target_id) {
    console.log({ target_id });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const item = dummy.details.find((v) => v.target_id == target_id);
        resolve({ success: true, item });
      }, 500);
    });
  }

  /**
   * 解析結果 文章
   * @param {number} target_id
   * @param {number} type 1:旧影武者／duplication　2:ちよこ／similarity
   */
  requestContent(target_id, type) {
    console.log({ target_id, type });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const item = dummy.details.find((v) => v.target_id == target_id);
        resolve({
          success: true,
          origin: dummy.content.origin,
          target: dummy.content.target,
        });
      }, 500);
    });
  }

  /**
   * 重複箇所
   * @param {number} target_id ターゲットID
   */
  requestDuplication(target_id) {
    console.log({ target_id });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ success: true, items: dummy.duplications });
      }, 500);
    });
  }

  /**
   * 類似箇所
   * @param {number} target_id ターゲットID
   */
  requestSimilarity(target_id) {
    console.log({ target_id });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ success: true, items: dummy.similarities });
      }, 500);
    });
  }

  /**
   * 解析結果 ワードクラウド
   * @param {number} target_id ターゲットID
   */

  requestKeyphrase(target_id) {
    console.log({ target_id });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          success: true,
          origin: dummy.keyphrase.origin,
          target: dummy.keyphrase.target,
        });
      }, 500);
    });
  }

  /**
   * 解析結果 レーダーチャート
   * @param {number} target_id ターゲットID
   */
  requestRadar(target_id) {
    console.log({ target_id });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          success: true,
          data: dummy.radar,
        });
      }, 500);
    });
  }
}

class Api extends Sync {
  constructor() {
    super();
    this.api = "/ap/v1/results/";
  }

  /**
   * 解析結果一覧
   *
   * @param {number} analytic_id 解析ID
   */
  requestPages(analytic_id) {
    return this.post(this.api + "items/", { analytic_id });
  }

  /**
   * 解析結果詳細
   * @param {number} target_id
   */
  requestPageDetail(target_id) {
    return this.post(this.api + "detail/", { target_id });
  }

  /**
   * 解析結果 文章
   * @param {number} target_id
   * @param {number} type 1:旧影武者／duplication　2:ちよこ／similarity
   */
  requestContent(target_id, type) {
    return this.post(this.api + "content/", { target_id, type });
  }

  /**
   * 重複箇所
   * @param {number} target_id ターゲットID
   */
  requestDuplication(target_id) {
    return this.post(this.api + "duplication/", { target_id });
  }

  /**
   * 類似箇所
   * @param {number} target_id ターゲットID
   */
  requestSimilarity(target_id) {
    return this.post(this.api + "similarity/", { target_id });
  }

  /**
   * 解析結果 ワードクラウド
   * @param {number} target_id ターゲットID
   */
  requestKeyphrase(target_id) {
    return this.post(this.api + "keyphrase/", { target_id });
  }

  /**
   * 解析結果 レーダーチャート
   * @param {number} target_id ターゲットID
   */
  requestRadar(target_id) {
    return this.post(this.api + "radar/", { target_id });
  }
}

const api = window.__ENABLE_MOCK__ ? new Mock() : new Api();

export { api };
